<script setup lang="ts">
import { useSnackbarStore } from '@/store/snackbar'
import { $signAnnotationCommentCreate } from '@/api/signs'

interface IProps {
  modelValue: boolean,
  parentAnnotation: any,
}

const props = withDefaults(defineProps<IProps>(), {
  modelValue: false,
  parentAnnotation: null,
})
interface Emit {
  (e: 'update:modelValue', value: boolean): void
  (e: 'onClose'): void
  (e: 'onSubmit'): void
}

const emit = defineEmits<Emit>()

const snackbarStore = useSnackbarStore()

const comment = ref('')

const createComment = async () => {
  if (!props?.parentAnnotation?.id) return

  const payload = {
    content: comment.value,
    annotation: props.parentAnnotation.id
  }
  try {
    await $signAnnotationCommentCreate(payload)
    closeDialog()
    snackbarStore.showMessage({
      color: 'success',
      icon: 'mdi-checkbox-marked-circle',
      title: 'Success',
      text: 'Comment saved!'
    })
    emit('onSubmit')
  } catch (e) {
    console.log(e)
  }
}

const closeDialog = () => {
  emit('update:modelValue', !props.modelValue)
}

const onClose = async () => {
  comment.value = ''
  emit('onClose')
}
</script>

<template>
  <VDialog
    :model-value="modelValue"
    max-width="600"
    class="default-dialog"
    @after-leave="onClose"
    @update:modelValue="emit('update:modelValue')"
  >
    <VBtn
      variant="elevated"
      density="compact"
      icon="tabler-x"
      class="v-dialog-close-btn"
      @click="closeDialog"
    />

    <VCard title="Comment Annotation">
      <VCardText>
        <VRow
          v-if="parentAnnotation"
        >
          <VCol>
            <h4>
              {{ parentAnnotation?.username }} at {{ parentAnnotation?.created_at }}:
            </h4>
            <p>{{ parentAnnotation?.comment }}</p>
          </VCol>
        </VRow>
        <VRow>
          <VCol class="py-0">
            <VTextarea
              v-model="comment"
              label="Comment"
            />
          </VCol>
        </VRow>
        <VRow>
          <VCol
            class="d-flex justify-end"
            cols="12"
          >
            <VBtn
              variant="outlined"
              @click="createComment"
            >
              Save
            </VBtn>
          </VCol>
        </VRow>
      </VCardText>
    </VCard>
  </VDialog>
</template>
